import { render, staticRenderFns } from "./TrainingCard.vue?vue&type=template&id=2d318c67"
import script from "./TrainingCard.vue?vue&type=script&lang=js"
export * from "./TrainingCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingCard.vue?vue&type=style&index=0&id=2d318c67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports